module.exports = __webpack_public_path__ + "img/vermelho.png";